// extracted by mini-css-extract-plugin
export var quantityInput = "_oh-0";